.media-minimal-skin {
  --media-popup-transition:
    opacity var(--media-popup-transition-timing-function) var(--media-popup-transition-duration),
    filter var(--media-popup-transition-timing-function) var(--media-popup-transition-duration),
    transform var(--media-popup-transition-timing-function) var(--media-popup-transition-duration),
    scale var(--media-popup-transition-timing-function) var(--media-popup-transition-duration);
}

.media-minimal-skin .media-popover,
.media-minimal-skin .media-tooltip {
  --media-popup-translate-distance: calc(var(--media-spacing) * 2);
  margin: 0;
  overflow: visible;
  color: inherit;
  border: 0;
  transition: var(--media-popup-transition);

  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
    /* We have to use transform here for translate as the translate property is used for positioning by core. */
    transform: translate(var(--media-popup-translate-x-distance, 0), var(--media-popup-translate-y-distance, 0));
    scale: 0.95;
  }

  &[data-ending-style] {
    filter: blur(4px);
    transform: none;
    /* Speed up the exit transition. */
    transition-duration: max(0ms, calc(var(--media-popup-transition-duration) - 50ms));
  }

  &[data-side="top"] {
    --media-popup-translate-y-distance: var(--media-popup-translate-distance);
    transform-origin: bottom;
  }
  &[data-side="bottom"] {
    --media-popup-translate-y-distance: calc(var(--media-popup-translate-distance) * -1);
    transform-origin: top;
  }
  &[data-side="left"] {
    --media-popup-translate-x-distance: var(--media-popup-translate-distance);
    transform-origin: right;
  }
  &[data-side="right"] {
    --media-popup-translate-x-distance: calc(var(--media-popup-translate-distance) * -1);
    transform-origin: left;
  }

  /* Safe area between trigger and popup */
  &::before {
    position: absolute;
    pointer-events: inherit;
    content: "";
  }

  &[data-side="top"]::before,
  &[data-side="bottom"]::before {
    inset-inline: 0;
    width: 100%;
  }
  &[data-side="top"]::before {
    top: 100%;
  }
  &[data-side="bottom"]::before {
    bottom: 100%;
  }

  &[data-side="left"]::before,
  &[data-side="right"]::before {
    inset-block: 0;
    height: 100%;
  }
  &[data-side="left"]::before {
    left: 100%;
  }
  &[data-side="right"]::before {
    right: 100%;
  }
}

.media-minimal-skin .media-popover {
  &[data-side="top"]::before,
  &[data-side="bottom"]::before {
    height: var(--media-popover-side-offset);
  }
  &[data-side="left"]::before,
  &[data-side="right"]::before {
    width: var(--media-popover-side-offset);
  }
}

.media-minimal-skin .media-tooltip {
  padding: calc(var(--media-spacing) * 1) calc(var(--media-spacing) * 2);
  font-size: var(--media-font-size-base);
  color: var(--media-tooltip-text-color);
  white-space: nowrap;
  background-color: var(--media-tooltip-background-color);
  border-radius: calc(var(--media-spacing) * 2);
  box-shadow:
    0 0 0 1px var(--media-tooltip-border-color),
    0 4px 6px -1px oklch(0 0 0 / 0.2),
    0 2px 4px -2px oklch(0 0 0 / 0.2);
  backdrop-filter: var(--media-tooltip-backdrop-filter);

  /* `display: flex` must not apply while closed — it overrides UA `[popover]` hiding. */
  &[data-open] {
    display: flex;
    column-gap: calc(var(--media-spacing) * 1);
    align-items: center;
  }

  &[data-side="top"]::before,
  &[data-side="bottom"]::before {
    height: var(--media-tooltip-side-offset);
  }
  &[data-side="left"]::before,
  &[data-side="right"]::before {
    width: var(--media-tooltip-side-offset);
  }

  .media-tooltip__kbd {
    min-width: 1.5em;
    padding: 0.1em;
    margin-right: calc(var(--media-spacing) * -1);
    font-family: inherit;
    font-size: var(--media-font-size-small);
    font-weight: 600;
    line-height: 1.25;
    text-align: center;
    background-color: oklch(from currentColor l c h / 0.15);
    border-radius: calc(var(--media-spacing) * 1);
  }
}

.media-minimal-skin .media-popover--volume:has(media-volume-slider[data-hidden]) {
  display: none;
}
